// extracted by mini-css-extract-plugin
export default {"alignRightWrapper":"alignRightWrapper---B0M95"};